// extracted by mini-css-extract-plugin
export default {"container":"TrustpilotBlock_container__dqodW","widget":"TrustpilotBlock_widget__HwThL"};